import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { ServiceSector, Transaction } from "../../../../models";
import { EmployeeAccount } from "../../../../models";
import { Stack } from "@mui/material";
import { Employee } from "../../../../models";
import { formatCurrency, formatDate } from "../../../../utils/formatters";
import { SideDrawer } from "../../../shared/SideDrawer";
import { useCustomQuery, useData } from "../../../../utils/useData";
import { useEffect, useState } from "react";

export const TransactionInfoSideDrawer = ({ selectedTransactionId, isOpen, setIsOpen } : { 
    selectedTransactionId: string | undefined | null;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
  }) => {
    const { employer, employees, plans, serviceSectors } = useData();
    const [employee, setEmployee] = useState<Employee | null>(null);

    const transaction = useCustomQuery<Transaction>({
        endpoint: `/transactions/${selectedTransactionId}?employerId=${employer.data?.id}`,
        options: {
          enabled: !!selectedTransactionId
        }
    });

    useEffect(() => {
        if (transaction.data && employees.data?.items) {
          const employee = employees.data?.items.find(
            (e) => e.id === transaction.data?.employeeId
          );
    
          if (employee) {
            setEmployee(employee);
          }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [transaction.data, employees.data]);

    return (
        <SideDrawer
            title="Transaction Info"
            open={isOpen}
            setIsOpen={() => setIsOpen(false)}
        >
            <Stack spacing={3} mx={2}>
                <Box>
                    <Typography variant="subtitle2" color="black" fontWeight="bold">
                        Merchant
                    </Typography>
                    <Typography variant="body1">
                        {transaction?.data?.cardAcceptor || "-"}
                    </Typography>
                </Box>
        
                <Box>
                    <Typography variant="subtitle2" color="black" fontWeight="bold">
                        Type
                    </Typography>
                    <Typography variant="body1">{transaction?.data?.type || "-"}</Typography>
                </Box>
        
                <Box>
                    <Typography variant="subtitle2" color="black" fontWeight="bold">
                        Date
                    </Typography>
                    <Typography variant="body1">
                        {formatDate(transaction?.data?.createdAt)}
                    </Typography>
                </Box>
        
                <Box>
                    <Typography variant="subtitle2" color="black" fontWeight="bold">
                        Amount
                    </Typography>
                    <Typography variant="body1">
                        {formatCurrency(transaction?.data?.billingAmount.amount ?? 0)}
                    </Typography>
                </Box>
        
                <Box>
                    <Typography variant="subtitle2" color="black" fontWeight="bold">
                        Charges
                    </Typography>
                    <Stack spacing={1}>
                        {transaction?.data?.charges?.map((charge) => {
                        const plan = plans?.data?.items?.find(
                            (p) => p.id === charge.planId
                        );
            
                        if (!plan) return null;
            
                        return (
                            <Typography key={plan.id} variant="body1">
                            {plan.name} - {formatCurrency(charge.amount.amount)}
                            </Typography>
                        );
                        })}
                    </Stack>
                </Box>
        
                <Box>
                    <Typography variant="subtitle2" color="black" fontWeight="bold">
                        User
                    </Typography>
                    <Typography variant="body1">
                        {employee?.firstName && employee?.lastName
                        ? `${employee.firstName} ${employee.lastName}`
                        : "-"}
                    </Typography>
                </Box>
        
                <Box>
                    <Typography variant="subtitle2" color="black" fontWeight="bold">
                        Category
                    </Typography>
                    <Typography variant="body1">
                        {serviceSectors?.data?.items?.find(
                        (s: ServiceSector) => s.id === transaction?.data?.serviceSectorId
                        )?.name || "-"}
                    </Typography>
                </Box>
            </Stack>
        </SideDrawer>
  );
};